<template lang="pug">
b-modal#getRecentDeposit(
  ref="getRecentDeposit"
  :title="$t('ui.combine.get_recent_deposit')"
  centered
  no-fade
  no-close-on-backdrop
  size="xl"
  :busy="loading"
  ok-only
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    div
      b-form-group(:label="$t('ui.recent_deposit')").mb-3
        div.row.mb-3.animated.fadeIn
          div.col
            .clusterize-scroll.table-responsive
              table.table.table-sm.table-bordered.table-striped.table-hover
                thead.thead-light
                  tr
                    th.text-center(width="3%")
                      span #
                    th(width="5%")
                      span {{ $t('ui.id') }}
                    th(width="8%")
                      span {{ $t('ui.member_id') }}
                    th(width="5%")
                      span {{ $tc('ui.banks', 1) }}
                    th(width="8%")
                      span {{ $t('ui.bank_acc_no') }}
                    th(width="8%")
                      span {{ $t('ui.bank_acc_holder') }}
                    th.text-right(width="8%")
                      span {{ $t('ui.amount') }}
                    th(width="10%")
                      span {{ $t('ui.promo') }}
                    th.text-right(width="10%")
                      span {{ $t('ui.bonus_amount') }}
                    th
                      span {{ $t('ui.remark') }}
                    th.text-right(width="10%")
                      span {{ $t('ui.modified_date') }}
                    th.text-right(width="10%")
                      span {{ $t('ui.created_date') }}
                tbody
                  tr(v-if="depositList.length == 0")
                      td(colspan="13").text-center
                        span {{ $t('message.no_data_available') }}
                  tr(v-for="(item, index) in depositList")
                    td.text-center
                      span(:title="index + 1") {{ index + 1 }}
                    td
                      span(:title="item.id") {{ item.id }}
                    td
                      span(:title="item.member_id") {{ item.member_id }}
                    td
                      span(:title="item.target_bank_id") {{ item.target_bank_id }}
                    td
                      span(:title="item.target_bank_acc_no") {{ item.target_bank_acc_no }}
                    td
                      span(:title="item.target_bank_acc_holder") {{ item.target_bank_acc_holder }}
                    td.text-right
                      span.font-weight-bold(:class="$helpers.fontClassName(item.amount)") {{ $n(item.amount, 'currency') }}
                    td
                      span(:title="item.promotion_id") {{ item.promotion_id }}
                    td.text-right
                      span.font-weight-bold(:class="$helpers.fontClassName(item.bonus_amount)") {{ $n(item.bonus_amount, 'currency') }}
                    td
                      span(:title="item.remark") {{ item.remark }}
                    td.text-right
                      span(v-if="item.modified_date" :title="$moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.modified_date).format('YYYY-MM-DD, HH:mm:ss') }}
                    td.text-right
                      span(v-if="item.created_date" :title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
      b-form-group(:label="$t('ui.recent_inbox_claim')").mb-3
        div.row.mb-3.animated.fadeIn
          div.col
            .clusterize-scroll.table-responsive
              table.table.table-sm.table-bordered.table-striped.table-hover
                thead.thead-light
                  tr
                    th.text-center(width="5%")
                      span #
                    th(width="15%")
                      span {{ $t('ui.member_id') }}
                    th.text-right(width="10%")
                      span {{ $t('ui.amount') }}
                    th(width="20%")
                      span {{ $t('ui.campaign') }}
                    th(width="35%")
                      span {{ $t('ui.remark') }}
                    th.text-right(width="15%")
                      span {{ $t('ui.claim_date') }}
                tbody
                  tr(v-if="claimList.length == 0")
                      td(colspan="6").text-center
                        span {{ $t('message.no_data_available') }}
                  tr(v-for="(item, index) in claimList")
                    td.text-center
                      span(:title="index + 1") {{ index + 1 }}
                    td
                      span(:title="item.member_id") {{ item.member_id }}
                    td.text-right
                      span.font-weight-bold(:title="$n(item.amount, 'currency')" :class="$helpers.fontClassName(item.amount)") {{ $n(item.amount, 'currency') }}
                    td
                      span(:title="item.campaign") {{ item.campaign }}
                    td
                      span(:title="item.remark") {{ item.remark }}
                    td.text-right
                      span(v-if="item.claim_date" :title="$moment(item.claim_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.claim_date).format('YYYY-MM-DD, HH:mm:ss') }}
    div.row
      div.col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fas fa-check" :text="$t('ui.ok')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, requiredIf } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);
const greaterThanZero = (value) => value > 0;

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      account_id: '',
      depositList: [],
      claimList: [],
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      operatorID: ''
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    }
  },
  methods: {
    getRecentDeposit: function() {
      let url = config.recentDepositUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.item.parent_id,
        member_id: this.item.member_id
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.depositList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getRecentInboxClaim: function() {
      let url = config.recentInboxClaimUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.item.parent_id,
        member_id: this.item.member_id
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.claimList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.account_id = this.item.member_id;
      this.operatorID = this.item.parent_id
      this.getRecentDeposit();
      this.getRecentInboxClaim();
    }
  }
};
</script>
